import React, { Component } from 'react';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import './MypageStyle.css';
import { Container, Col, Row, Card, Accordion } from 'react-bootstrap'
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel'
import ClipLoader from "react-spinners/ClipLoader";
import Modal from 'react-modal'
import axios from 'axios';
import moment from 'moment';

import firebase from 'lib/firebase';
import api from 'lib/api';
import global from 'lib/global';
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link';
import HeaderWrite from '../Components/HeaderWrite';
import MypageAccountItem from './MypageAccountItem';
import MypageClassItem from './MypageClassItem';
import MypageLicenseItem from './MypageLicenseItem';

import * as UserActions from 'store/modules/UserModule';


class MypageScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // 알림모달
            visibleAlert: false,
            alert: '',

            // 마이페이지
            userInfo: {},
            // modifyOnOff: false,
            myTab: 0,

            // class_data: [],
            // license_data: [],
            // page: 0,
            // page_all: [],

            // imageLoading: false,
        }
    }

    componentDidMount() {
        const self = this;

        firebase.auth().onAuthStateChanged(async function (user) {
            let userData = await self.props.userActions.getUserInfo();
            if (userData.data.result) {
                self.setState({ userInfo: userData.data.data });
            }
        });
    }

    onClickLoginGoogle = async (e) => {
        const self = this;

        var provider = new firebase.auth.GoogleAuthProvider();
        firebase.auth().signInWithPopup(provider)
            .then(async function (result) {
                let userData = await self.props.userActions.getUserInfo();
                if (userData.data.result) {
                    self.setState({ userInfo: userData.data.data });
                }
            }).catch(function (error) {
                console.log("login err", error)
            });
    }

    onClickLogout = () => {
        console.log("click Logout")
        const self = this;

        firebase.auth().signOut().then(() => {
            console.log("Logout")
            self.props.userActions.setUserInfo({});
            self.setState({ userInfo: {} })
        }).catch((error) => {
            console.log("Logout err")
        });
    }

    // onClickCamera = () => {
    //     console.log("try to change profile pic")
    //     this.refs.fileUploader.click();
    // }
    // handleImageChange = async (e) => {
    //     const self = this;

    //     let files = e.target.files;
    //     let token = await firebase.auth().currentUser.getIdToken(true);
    //     if (!token) {
    //         return;
    //     }

    //     //fileupload
    //     const url = global.url_api + '/workbook/imageUpload/upload';
    //     let formData = new FormData();
    //     formData.append('file', files[0]);
    //     formData.append('category', 'profile');
    //     const config = {
    //         headers: {
    //             'accept': 'application/json',
    //             'content-type': 'multipart/form-data',
    //             'Access-Control-Allow-Origin': '*',
    //             'Authorization': token,
    //         }
    //     }

    //     this.setState({ fileLoading: true });
    //     axios.post(url, formData, config)
    //         .then(async function (response) {
    //             self.setState({ fileLoading: false });
    //             let data = response.data;
    //             //성공
    //             if (data.result) {
    //                 //유저정보 다시 불러오기
    //                 let userData = await self.props.userActions.getUserInfo();
    //                 if (userData.data.result) {
    //                     self.setState({ userInfo: userData.data.data });
    //                 }

    //                 self.setState({
    //                     message: "memo",
    //                     isSubmit: false,
    //                     alert: "Upload complete!",
    //                     visibleAlert: !self.state.visibleAlert
    //                 });
    //                 e.target.value = null;
    //             } else {
    //                 self.setState({
    //                     alert: "Please try again.",
    //                     visibleAlert: !self.state.visibleAlert
    //                 })
    //             }
    //         })
    //         .catch(function (err) {
    //             self.setState({ fileLoading: false });
    //         })
    // };

    //유저정보 수정
    // onClickModify = () => {
    //     // console.log("click modify")
    //     const self = this;

    //     let item = this.props.userInfo;
    //     if (item.level != this.state.userInfo.level || item.nick_name != this.state.userInfo.nick_name) {
    //         api.post('/workbook/users/change', { item: this.state.userInfo })
    //             .then(async function (result) {
    //                 if (result) {
    //                     // console.log("dataChange result", result)
    //                     self.setState({
    //                         alert: "Completed",
    //                         // visibleAlert: !self.state.visibleAlert,
    //                         visibleAlert: true,
    //                     })

    //                     //유저정보 다시 불러오기
    //                     let userData = await self.props.userActions.getUserInfo();
    //                     if (userData.data.result) {
    //                         self.setState({
    //                             userInfo: userData.data.data,
    //                             modifyOnOff: false,
    //                         });
    //                     }
    //                 }
    //             })
    //     } else {
    //         console.log("user informations are same")
    //     }
    // }

    onClickTabNo0 = () => {
        this.setState({ myTab: 0 })
    }

    onClickTabNo1 = () => {
        this.setState({ myTab: 1 })

        // const self = this;
        // api.post('/workbook/workbook/list', {})
        //     .then(function (result) {
        //         if (result.data.result) {
        //             let data = result.data.data;
        //             let countPage = data.length;

        //             self.setState({
        //                 myTab: 1,
        //                 class_data: data,
        //                 page_all: countPage,
        //             });
        //         }
        //     })
        //     .catch(err => {
        //         console.log("tab err", err)
        //     })
    }

    onClickTabNo2 = () => {
        this.setState({ myTab: 2 })

        // const self = this;
        // api.post('/workbook/pay/list', {})
        //     .then(function (result) {
        //         if (result.data.result) {
        //             let data = result.data.data;
        //             self.setState({ license_data: data });
        //         }
        //     })
        //     .catch(err => {
        //         console.log("tab err", err)
        //     })
    }

    // onClickClassPage = (e) => {
    //     // console.log("click page:", e.target.innerText)
    //     this.setState({ page: e.target.innerText - 1 })
    // }

    // onClickClassPagePre = () => {
    //     // console.log("click page pre")
    //     if (this.state.page > 0) {
    //         this.setState({ page: this.state.page - 1 })
    //     }
    //     return;
    // }

    // onClickClassPageNext = () => {
    //     // console.log("click page next")
    //     let maxPage = Math.round(this.state.page_all / 3);
    //     if (this.state.page < maxPage) {
    //         this.setState({ page: this.state.page + 1 })
    //     }
    //     return;
    // }

    // onChangeLevel = (e) => {
    //     let item = this.state.userInfo;
    //     item['level'] = e.target.value;
    //     this.setState({ userInfo: item })

    //     if (this.props.userInfo.level != this.state.userInfo.level) {
    //         this.setState({
    //             modifyOnOff: true
    //         })
    //     } else if (this.props.userInfo.level == this.state.userInfo.level && this.props.userInfo.nick_name == this.state.userInfo.nick_name) {
    //         this.setState({
    //             modifyOnOff: false
    //         })
    //     }

    // }

    // onChangeUserNick = (e) => {
    //     console.log("input name")

    //     let name = e.target.value;
    //     var regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi; //특수문자 제거
    //     name = name.replace(regExp, "");

    //     let item = this.state.userInfo;
    //     item['nick_name'] = name;
    //     this.setState({ userInfo: item })

    //     if (this.props.userInfo.nick_name != this.state.userInfo.nick_name) {
    //         this.setState({
    //             modifyOnOff: true
    //         })
    //     } else if (this.props.userInfo.level == this.state.userInfo.level && this.props.userInfo.nick_name == this.state.userInfo.nick_name) {
    //         this.setState({
    //             modifyOnOff: false
    //         })
    //     }
    // }


    render() {
        // console.log("props.. ", this.props.userInfo)
        let LayoutMypage;

        if (this.props.userInfo && this.props.userInfo.idx) {
            let LayoutTab;
            let tabOn = { color: '#ce3b33', borderBottomWidth: 2, borderBottomColor: '#ce3b33', borderBottomStyle: 'solid', paddingBottom: 10 };

            // let userProfile = '/profile_empty.png'
            // if (this.state.userInfo.photo != null && this.state.userInfo.photo.length > 0) {
            //     userProfile = this.state.userInfo.photo;
            // }

            if (this.state.myTab == 0) {
                LayoutTab = <MypageAccountItem />
                // LayoutTab = (
                //     <Container className="mypage_account">
                //         <Row style={{
                //             borderBottomWidth: 1, borderBottomColor: '#eee', borderBottomStyle: 'solid',
                //             paddingTop: 30, paddingBottom: 30
                //         }}>
                //             <Col xs={12} sm={12} md={3} lg={3} style={{}}>
                //                 <div className="profile">
                //                     <img src={userProfile} alt="profile" style={{ width: '100%', height: '100%' }} />
                //                 </div>
                //                 <div className="camera" onClick={this.onClickCamera}>
                //                     <img src={"/write/my_icon_camera.png"} alt="camera" style={{ width: '70%' }} />
                //                 </div>
                //             </Col>
                //             <Col xs={12} sm={12} md={9} lg={9} style={{}}>
                //                 <input type="text" placeholder="Nickname" onChange={this.onChangeUserNick} value={this.state.userInfo.nick_name} />
                //                 <p>{this.state.userInfo.email}</p>
                //                 <select onChange={this.onChangeLevel} value={this.state.userInfo.level}>
                //                     <option value={0} disabled hidden>Level select</option>
                //                     <option value={1}>Beginner</option>
                //                     <option value={2}>Intermediate - Advanced</option>
                //                 </select>
                //             </Col>
                //         </Row>
                //         <div className="modify" onClick={this.onClickModify} style={this.state.modifyOnOff == true? {backgroundColor:'#ce3b33'}: {backgroundColor:'#ccc'}}>Modify</div>
                //     </Container>
                // )

            } else if (this.state.myTab == 1) {
                LayoutTab = <MypageClassItem />
                // let self = this;

                // let listClass = [];
                // this.state.class_data.forEach(function (data, index) {
                //     let code_url = "https://workbook.boomco.io/sub/" + data.code;

                //     let getDate = moment(data.send_date).format("YYYY-MM-DD");
                //     let item = [(
                //         <Row className="classContainer">
                //             <Col xs={2} md={2} className="my-auto classDate" style={{ textAlign: 'center', padding: 0 }}>
                //                 <p>{data.round}</p>
                //                 <p>{getDate}</p>
                //             </Col>
                //             <Col xs={10} md={6} className="my-auto classTitle">
                //                 <a href={code_url} target={"_blank"}>{data.title}</a>
                //             </Col>
                //             <Col xs={6} md={2} className="my-auto classIcon">
                //                 <img
                //                     src={data.get_type > 0 ? "/write/my_icon_submitted_on.png" : "/write/my_icon_submitted_off.png"}
                //                     alt="icon_submitted" className="progressIcon" />
                //             </Col>
                //             <Col xs={6} md={2} className="my-auto classIcon">
                //                 <img
                //                     src={data.edit_type > 0 ? "/write/my_icon_feedback_on.png" : "/write/my_icon_feedback_off.png"}
                //                     alt="icon_feedback" className="progressIcon" />
                //             </Col>
                //         </Row>
                //     )];
                //     listClass.push(item)
                // })
                // let sliceListClass = listClass.slice(this.state.page * 3, this.state.page * 3 + 3)


                // // class list pages
                // let stylePageOn = { marginLeft: '1%', marginRight: '1%', color: '#ce3b33', borderBottomWidth: 1, borderBottomColor: '#ce3b33', borderBottomStyle: 'solid', paddingBottom: 3 };
                // let stylePageOff = { marginLeft: '1%', marginRight: '1%', color: '#999', borderBottomWidth: 0 };
                // let listPage = [];
                // var i = 0;
                // for (i = 0; i < this.state.page_all / 3; i++) {
                //     let labelPage = i + 1;
                //     let item = (
                //         <span onClick={(e) => this.onClickClassPage(e)} style={this.state.page == i ? stylePageOn : stylePageOff}>{labelPage}</span>
                //     );
                //     listPage.push(item)
                // }

                // LayoutTab = (
                //     <Container className="mypage_class">
                //         {sliceListClass}
                //         <Container style={{ color: '#999', textAlign: 'center', marginTop: '5%', cursor: 'pointer' }}>
                //             <span onClick={this.onClickClassPagePre}>Pre</span>
                //             <span style={{ marginLeft: '4%', marginRight: '4%' }}>{listPage}</span>
                //             <span onClick={this.onClickClassPageNext}>Next</span>
                //         </Container>
                //     </Container>
                // )

            } else if (this.state.myTab == 2) {
                LayoutTab = <MypageLicenseItem />
                // license list rendering
                // let license_list = [];
                // this.state.license_data.forEach(function (data) {
                //     let dateTime = moment(data.pay_date).format("yyyy.MM.DD") + " ~ " + moment(data.pay_end).format("yyyy.MM.DD");
                //     let item = (
                //         <Row className="classContainer" style={{
                //             borderBottomWidth: 1, borderBottomColor: '#eee', borderBottomStyle: 'solid',
                //             paddingTop: '2%', paddingBottom: '2%',
                //         }}>
                //             <Col xs={12} md={5} className="my-auto" style={{ textAlign: 'left' }}>
                //                 <p style={{ color: "#666", fontWeight: '500', margin: 0 }}>{data.title}</p>
                //                 {/*<p style={{ margin: 0, fontSize: 13 }}>{data.sub_name}</p>*/}
                //             </Col>
                //             <Col xs={3} md={1} className="my-auto" style={{ color: "#666", fontWeight: '500' }}>{data.pay_money}$</Col>
                //             <Col xs={3} md={2} className="my-auto">{data.pay_module}</Col>
                //             <Col xs={6} md={4} className="my-auto period">{dateTime}</Col>
                //         </Row>
                //     )
                //     license_list.push(item);
                // })

                // // license layout
                // LayoutTab = (
                //     <Container className="mypage_license">
                //         {license_list}
                //     </Container>
                // )
            }
            
            LayoutMypage = (
                <div id="write_mypage">
                    <div style={{ backgroundColor: '#ce3b33', paddingTop: 70 }}>
                        <Container className="tab" style={{ maxWidth: 800, paddingTop: 45, paddingBottom: '8%' }}>
                            <h2 style={{ color: '#fff', fontWeight: '300' }}>My Page</h2>
                            <Container className="mypage_tabBar">
                                <Container>
                                    <Row style={{ padding: 0, color: '#999' }}>
                                        <Col xs={3} sm={3} md={2} lg={2} style={{}}>
                                            <a onClick={this.onClickTabNo0} style={this.state.myTab == 0 ? tabOn : { borderBottomWidth: 0 }}>Account</a>
                                        </Col>
                                        <Col xs={3} sm={3} md={2} lg={2}>
                                            <a onClick={this.onClickTabNo1} style={this.state.myTab == 1 ? tabOn : { borderBottomWidth: 0 }}>Classes</a>
                                        </Col>
                                        <Col xs={3} sm={3} md={2} lg={2}>
                                            <a onClick={this.onClickTabNo2} style={this.state.myTab == 2 ? tabOn : { borderBottomWidth: 0 }}>License</a>
                                        </Col>
                                        <Col xs={1} sm={0} md={4} lg={4}></Col>
                                        <Col xs={1} sm={2} md={2} lg={2} style={{ textAlign: 'right' }}>
                                            <a
                                                onClick={this.onClickLogout}
                                                style={{ fontSize: 11, borderBottomWidth: 1, borderBottomColor: '#999', borderBottomStyle: 'solid', paddingBottom: 2 }}>
                                                Logout
                                            </a>
                                        </Col>
                                    </Row>
                                </Container>
                                <Container style={{
                                    width: '96%',
                                    marginTop: 8, padding: 0,
                                    borderTopWidth: 1, borderTopColor: '#eee', borderTopStyle: 'solid',
                                }}>
                                    {LayoutTab}
                                </Container>
                            </Container>
                        </Container>
                    </div>
                </div>
            );

        } else {
            LayoutMypage = (
                <div style={{ backgroundColor: '#ce3b33', paddingTop: 150, paddingBottom: 80 }}>
                    <div id="goGoogleContainer">
                        <Container className="loginGoogle" onClick={this.onClickLoginGoogle}>
                            <Row>
                                <Col xs={0} md={1}></Col>
                                <Col xs={2} md={2}>
                                    <img src={"/write/my_logo_google.png"} alt="goggle login" style={{ width: 25, height: 25, backgroundColor: "yellow" }} />
                                </Col>
                                <Col xs={10} md={8}>
                                    <p style={{ color: '#666' }}>Continue with Google</p>
                                </Col>
                                <Col xs={0} md={1}></Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            );
        }

        return (
            <div id="write_ad">
                {/* header */}
                <HeaderWrite />

                {LayoutMypage}
                <input type="file" ref="fileUploader" style={{ display: "none" }} onChange={(e) => this.handleImageChange(e)} />

                <footer>
                    <img src={"/write/ad_logo_icon.png"} alt="boomco logo" style={{ height: '100%', marginBottom: '1%' }} />
                    <p>Copyright 2021. boomco</p>
                    <p>1:1 Customer Center : <a href="mailto:boomco@boomco.org">boomco@boomco.org</a></p>
                </footer>

                {/* modal(경고문) */}
                <Modal
                    isOpen={this.state.visibleAlert}
                    onRequestClose={() => this.setState({ visibleAlert: false })}
                    className="Alert"
                    overlayClassName="Overlay"
                >
                    <Container>
                        <Row>
                            <Col xs={2} sm={2} md={2} lg={2} className="my-auto">
                                <img src={"/write/ad_logo_icon.png"} alt="logo" style={{ width: '140%' }} />
                            </Col>
                            <Col xs={10} sm={10} md={10} lg={10} className="my-auto">
                                <div style={{ color: '#666' }}>{this.state.alert}</div>
                            </Col>
                        </Row>
                        <div className="alertClose" onClick={() => this.setState({ visibleAlert: !this.state.visibleAlert })}>Close</div>
                    </Container>
                </Modal>
            </div>
        )
    }
}




let mapStateToProps = (state) => ({
    userInfo: JSON.parse(JSON.stringify(state.UserModule.get('userInfo'))),
});

let mapDispatchToProps = (dispatch) => ({
    userActions: bindActionCreators(UserActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MypageScreen);